export const weatherBackgroundColorGradients = {
    "01d": { start: "#1C93FF", end: "#5CB9FF" },
    "01n": { start: "#4067F2", end: "#BA82DC" },
    "02d": { start: "#1C93FF", end: "#5CB9FF" },
    "02n": { start: "#4067F2", end: "#BA82DC" },
    "03d": { start: "#A2C8FB", end: "#D9EDFA" },
    "03n": { start: "#A2C8FB", end: "#D9EDFA" },
    "04d": { start: "#A2C8FB", end: "#D9EDFA" },
    "04n": { start: "#A2C8FB", end: "#D9EDFA" },
    "09d": { start: "#A3B9E1", end: "#A3B9E1" },
    "09n": { start: "#A3B9E1", end: "#A3B9E1" },
    "10d": { start: "#A3B9E1", end: "#A3B9E1" },
    "10n": { start: "#A3B9E1", end: "#A3B9E1" },
    "11d": { start: "#6E88B8", end: "#ADCFFD" },
    "11n": { start: "#6E88B8", end: "#ADCFFD" },
    "13d": { start: "#A2C8FB", end: "#D9EDFA" },
    "13n": { start: "#A2C8FB", end: "#D9EDFA" },
    "50d": { start: "#A2C8FB", end: "#D9EDFA" },
    "50n": { start: "#A2C8FB", end: "#D9EDFA" },
};
